import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateOrder } from '../store/slices/websocketSlice';

interface Order {
  id: string;
  status: string;
}

/**
 * Хук для автоматического удаления всех закрытых ордеров из стора
 */
const useRemoveClosedOrders = () => {
  const orders = useSelector((state: any) => state.websocket.orders as Order[]);
  const dispatch = useDispatch();
  const removedIdsRef = React.useRef<string[]>([]);

  useEffect(() => {
    orders.forEach((order: Order) => {
      if (order.status === 'closed' && !removedIdsRef.current.includes(order.id)) {
        removedIdsRef.current.push(order.id);
        dispatch(updateOrder({ id: order.id, status: 'closed' }));
      }
    });
  }, [orders, dispatch]);
};

export default useRemoveClosedOrders;
